import { useTheme } from "@mui/material";
import { Elements, useElements, useStripe } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useSelector } from "react-redux";
import { retrieveContactPaymentType } from "store/features/contact.store";
import i18n from "utility/i18next";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY, { locale: i18n.language });

const withStripe = (Component) => (props) => {
  const theme = useTheme();
  const { isCheckoutPaymentType } = useSelector(retrieveContactPaymentType);

  if (!isCheckoutPaymentType) return <Component {...props} />;
  return (
    <Elements
      stripe={stripePromise}
      options={{
        // eslint-disable-next-line react/prop-types
        clientSecret: props.secret,
        appearance: { theme: "stripe", variables: { fontFamily: theme.typography.fontFamily } },
        locale: i18n.language,
      }}
    >
      <Component {...props} />
    </Elements>
  );
};

const withStripeElements = (Component) => (props) => {
  const { isCheckoutPaymentType } = useSelector(retrieveContactPaymentType);

  if (!isCheckoutPaymentType) return <Component {...props} />;

  const stripe = useStripe();
  const elements = useElements();

  return <Component {...props} stripe={stripe} stripeElements={elements} />;
};

export { withStripe, withStripeElements };
